/*
 * Complete the set: the "Add" button on the product page (blocks/sis-complete-set) and in
 * the cart drawer (snippets/sis-cart-set). Adds the matching tee or hoodie, then lets
 * Horizon re-render the cart drawer and opens it.
 * - Product page: the button lists every variant; it adds the size picked above, or the
 *   first available size.
 * - Cart drawer: the button carries one variant (data-variant), already sized to match.
 */
import { CartAddEvent } from '@theme/events';

document.addEventListener('click', async (event) => {
  const button = event.target.closest('[data-sis-set-add]');
  if (!button || button.disabled) return;

  const variantId = button.dataset.variant || pickVariant(button);
  if (!variantId) return;
  button.disabled = true;

  const sectionIds = [...document.querySelectorAll('cart-items-component')]
    .map((el) => el.dataset.sectionId)
    .filter(Boolean);
  try {
    const response = await fetch(Theme.routes.cart_add_url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }], sections: sectionIds.join(',') }),
    });
    const data = await response.json();
    if (!response.ok) throw new Error(data.description || data.message);
    const cart = await (await fetch(`${Theme.routes.cart_url}.js`)).json();
    document.dispatchEvent(
      new CartAddEvent(cart, 'sis-complete-set', {
        source: 'sis-complete-set',
        itemCount: cart.item_count,
        variantId,
        sections: data.sections,
      })
    );
    document.querySelector('cart-drawer-component')?.open?.();
    if (button.dataset.addedText) button.textContent = button.dataset.addedText;
  } catch (error) {
    console.error(error);
    button.disabled = false;
  }
});

/** Product page: the size picked in the variant picker, or the first available size. */
function pickVariant(button) {
  const ids = button.dataset.variants.split(',');
  const sizes = button.dataset.sizes.split('|');
  const available = button.dataset.available.split(',');
  const picked = button
    .closest('.shopify-section')
    ?.querySelector('variant-picker input[type="radio"]:checked')?.value;
  let index = sizes.indexOf(picked);
  if (index < 0 || available[index] !== 'true') index = available.indexOf('true');
  return index < 0 ? null : ids[index];
}
